import React from 'react';
import useOrganizationPaymentIntegrationBranding from '../../../../../../../hooks/api/useOrganizationPaymentIntegrationBranding';
import { getIntl } from '../../../../../../../utils/intl';
import Alert from '../../../../../../v2BaseComponents/Alert';
import { useOrganizationTabNavigation } from '../../../../../../../utils/appNavigationNames';

const intl = getIntl('MissingBrandingAlert', {
    missingBranding: 'Your Stripe Account is Missing Branding.',
    missingBrandingDescription:
        "You either did not upload a logo or icon to your organization or they could not be transferred to your Stripe account.  Stripe enforces tighter restrictions on branding images than Primary Record does.  You can upload a logo and icon to ensure your client's invoicing experience is fully branded to your organization.",
    updateBranding: 'Update Branding',
});

export type MissingBrandingAlertOwnProps = {};

export type MissingBrandingAlertProps = MissingBrandingAlertOwnProps;

const MissingBrandingAlert: React.FC<MissingBrandingAlertProps> = (_props) => {
    const organizationNavigation = useOrganizationTabNavigation();
    const { isMissingBranding } = useOrganizationPaymentIntegrationBranding({});

    if (!isMissingBranding) return null;

    return (
        <Alert
            type="warning"
            title={intl('missingBranding')}
            message={intl('missingBrandingDescription')}
            actionItems={[
                {
                    title: intl('updateBranding'),
                    onPress: () => organizationNavigation.navigate('edit-client-billing-branding', {}),
                },
            ]}
        />
    );
};

export default React.memo(MissingBrandingAlert);
